import { render, staticRenderFns } from "./Assist.vue?vue&type=template&id=f57d5608&scoped=true"
import script from "./Assist.vue?vue&type=script&lang=js"
export * from "./Assist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57d5608",
  null
  
)

export default component.exports